<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<mat-select #selectControl="ngModel"
  [(value)]='value'
  [placeholder]="placeholder"
  [ngModel]="selectControl"
  [disabled]="!parameterValue">

  <mat-option [value]="undefined">-- Select --</mat-option>
  @for (opt of dropdownOptions$|async; track opt.value) {
    <mat-option [value]="opt.value">
      {{opt.text}}
    </mat-option>
  }

  @if ((selectControl.ngControl.invalid && (selectControl.ngControl.dirty || selectControl.ngControl.touched))) {
    <div role="alert">
      @if (selectControl.ngControl.hasError('pattern')) {
        <div>
          {{validationMessage}}
        </div>
      }
      @if (selectControl.ngControl.hasError('required')) {
        <div>
          {{field.displayName}} is required.
        </div>
      }
    </div>
  }

</mat-select>
